module.exports = __webpack_public_path__ + "img/table-icon.9b6594bb.svg";